import { createAsyncThunk } from "@reduxjs/toolkit";


export const downloadContextReport = createAsyncThunk(
    "downloadContext",
    async (values, { rejectWithValue }) => {
        console.log("values context file ==>", JSON.stringify(values));
        const token = window.localStorage.getItem("idToken");
        const response = await fetch(
            "https://6kgus2n703.execute-api.us-east-2.amazonaws.com/translationDev/Context/Context-Report",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer "+token
                },
                body: JSON.stringify(values),
            }
        );

        try {
        
            const result = await response.json();
            console.log("result", result);
            return {
                statusCode: 200,
                message: "success",
                result: result
              };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
